import React, { useState, useEffect } from 'react'

// Centralized lodash imports - much cleaner!
import { map, find, compact, get } from '@/utils/lodash'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone'
import CheckIcon from '@mui/icons-material/Check'
import CameraAltTwoToneIcon from '@mui/icons-material/CameraAltTwoTone'
import CreateNewOrg from '@/housefolios-components/OrganizationSettings/CreateNewOrg'

import {
  Grid,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  Menu,
  Tooltip,
  Typography,
  useMediaQuery,
  Box,
} from '@mui/material'

import { useDropzone } from 'react-dropzone'

import HousefoliosUser from '@/assets/images/Housefolios_user.png'

import withSession from '@/housefolios-components/Session/withSession'
import { IMAGE_UPLOAD } from '@/housefolios-components/TitleButtons/AddPropertyButton/mutations'
import { ApolloConsumer } from '@/components/ApolloConsumer'
import { useMutation } from '@apollo/client/react'
import { GET_ME } from '@/housefolios-components/Session/queries'
import { signOut } from '@/housefolios-components/SignOut'
import { UPDATE_USER } from '@/housefolios-components/PersonalSettings/mutations'
import { GET_PORTFOLIOS } from '@/housefolios-pages/Launchpad/queries'
import { GET_SIDEBAR_PORTFOLIOS } from '@/housefolios-components/Portfolio/queries'
import { enqueueSnackbar } from 'notistack'
import { useNavigate } from 'react-router'
import ColorModeToggle from '@/layout-components/ColorModeToggle'
import {
  headerUserActionBillingSx,
  headerUserActionLogoutSx,
  headerUserActionPrimarySx,
  headerUserMenuEmailSx,
  headerUserMenuGridSx,
  headerUserMenuNameSx,
  headerUserPlaceholderImgSx,
  headerUserUploadBtnSx,
  headerUserWhiteIconSx,
} from '@/layout-blueprints/chromeComponentSx'

const orgAvatarSx = {
  width: 40,
  height: 40,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}

function OrgStatusDot({ selected  }) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        width: 8,
        height: 8,
        borderRadius: '50%',
        bgcolor: selected ? '#1bc943' : '#797d95',
        mr: 1,
        flexShrink: 0,
      }}
    />
  )
}

function OrgSwitcherRow({
  name,
  selected,
  iconBg,
  children,
  ...buttonProps
}) {
  return (
    <ListItemButton
      {...buttonProps}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        py: 1.5,
        px: 2,
        bgcolor: '#fff',
        '&:hover': { bgcolor: 'grey.100' },
        'html[data-color-mode="dark"] &': {
          bgcolor: '#2a2a2a',
          '&:hover': { bgcolor: '#333' },
        },
      }}
    >
      <Box sx={{ ...orgAvatarSx, bgcolor: iconBg }}>
        {children}
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          noWrap
          sx={{ fontWeight: 700, fontSize: 13, color: '#070919', 'html[data-color-mode="dark"] &': { color: 'rgba(255, 255, 255, 0.87)' } }}
        >
          {name}
        </Typography>
        {selected != null && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mt: 0.25,
              fontSize: 12,
              color: selected ? '#1bc943' : '#797d95',
            }}
          >
            <OrgStatusDot selected={selected} />
            {selected ? 'Selected' : 'Not Selected'}
          </Box>
        )}
      </Box>
    </ListItemButton>
  )
}

const HeaderUserbox = (props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [files, setFiles] = useState([props.session.me.userImage])
  const [imageUpload] = useMutation(IMAGE_UPLOAD)
  const [updateUser] = useMutation(UPDATE_USER)
  const {
    isDragActive,
    isDragAccept,
    isDragReject,
    open,
    getRootProps,
    getInputProps,
  } = useDropzone({
    noClick: true,
    noKeyboard: true,
    multiple: false,
    accept: {
      'image/*': [],
    },
    onDrop: (acceptedFiles) => {
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      )
      map(acceptedFiles, (file) => {
        const reader = new FileReader()
        reader.onload = async () => {
          const userImage = reader.result
          imageUpload({
            variables: {
              documentId: props.session.me._id,
              imageUrls: [userImage],
              collection: 'teamMember',
            },
            refetchQueries: [{ query: GET_ME }],
          }).then(async ({ data  }) => {
            enqueueSnackbar('Image Saved', {
              variant: 'success',
              autoHideDuration: 3000,
            })
          })
        }
        reader.readAsDataURL(file)
      })
    },
  })

  let navigate = useNavigate()

  // const hiddenXsDown = useMediaQuery((theme) =>
  //   theme.breakpoints.down('xs'),
  // )

  const hostname = import.meta.env.VITE_HOSTNAME

  const dynamicSpacing =
    hostname === 'localhost' ||
    hostname === 'dev-admin.housefolios.com'
      ? 'mr-4'
      : 'mr-2'

  const thumbs = map(compact(files), (file, index) => (
    <Box key={file._id || file.name || file.url || `thumb-${index}`} sx={[{
      height: "140px !important",
      width: "140px !important",
      lineHeight: "140px !important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      p: 0,
      backgroundColor: "rgb(96.1617647059%, 96.1617647059%, 97.0147058824%) !important",
      borderRadius: "0.65rem",
      overflow: "hidden",
      textAlign: "center",
      fontWeight: 700,
      color: "#1bc943",
    }, {
      "& .blur-load": { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" },
    }]} data-hf="avatar-image">
      <Box sx={[{ backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }, { backgroundImage: `url(${file.url_small})` }]}>
        <Box component="img" src={file.url || file.preview} alt="..." loading="lazy" sx={[{ maxWidth: '100%', height: 'auto', borderRadius: '0.29rem', }, {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center",
        }]} />
      </Box>
    </Box>
  ))

  useEffect(
    () => () => {
      compact(files).forEach((file) =>
        URL.revokeObjectURL(file.preview),
      )
    },
    [files],
  )

  useEffect(() => {
    const me = props?.session?.me
    if (me?.userImage) setFiles([me.userImage])
  }, [props?.session?.me?.userImage])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const me = props?.session?.me
  const role = find(
    me?.roles || [],
    (role) => role?.organization?._id === me?.activeOrg?._id,
  )

  return (
    <>
      {!me ? null : (
        <Tooltip title="User Actions">
          <Button onClick={handleClick} disableRipple sx={{ flexShrink: 0, minWidth: 44 }}>
            <Box sx={[{ display: 'block', p: 0 }, {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              mr: "0.25rem",
              position: "relative",
              fontSize: "1.2rem",
              transition: "all 0.2s ease-in-out",
              "&:last-child": { mr: 0, marginRight: 0 },
              "& .badge": { position: "absolute", right: 0, bottom: 0 },
              "& svg, & .svg-inline--fa": { display: "block" },
              marginRight: "0.25rem",
            }]}>
              <Box sx={[{ borderRadius: '0.65rem', display: 'flex', justifyContent: 'center', alignItems: 'center', }, {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 44,
                height: 44,
                lineHeight: 1,
                borderRadius: 50,
                boxShadow: "0 0 0 3px #fff",
                overflow: "hidden",
                "& img": { width: "100%", height: "100%", display: "block" },
                "& svg, & .svg-inline--fa": { display: "block" },
                transition: "all 0.2s ease-in-out",
                opacity: 1,
                "&.rounded": { borderRadius: "0.65rem !important" },
                "html[data-color-mode=\"dark\"] &": { boxShadow: "0 0 0 2px rgba(255, 255, 255, 0.2)" },
              }]}>
                <Box
                  sx={[
                    { backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" },
                    {
                      backgroundImage: `url(${
                        compact(files).length > 0
                          ? compact(files)[0].url_small
                          : HousefoliosUser
                      })`,
                    },
                  ]}
                >
                  <img
                    src={
                      compact(files).length > 0
                        ? compact(files)[0].url
                        : HousefoliosUser
                    }
                    alt="..."
                    loading="lazy"
                  />
                </Box>
              </Box>
            </Box>
            <Box
             
              sx={[{
                "@media (min-width: 1440px)": { display: "block" },
              }, { display: 'none', pl: '0.5rem' }]}
            >
              <Box sx={[{ fontWeight: 700, pt: '0.5rem' }, {
                color: "#070919",
                "html[data-color-mode=\"dark\"] &": { color: "rgba(255, 255, 255, 0.87) !important" },
                lineHeight: "1 !important",
              }]}>
                {me?.profile?.firstname || ''}{' '}
                {me?.profile?.lastname || ''}
              </Box>
              <Box
                component="span"
                sx={{ color: 'rgba(7, 9, 25, 0.5)' }}
              >
                {role ? role.role[0] : ''}
              </Box>
            </Box>
            <Box
              component="span"
             
              sx={{
                "@media (min-width: 1440px)": { pl: "1rem" },
                pl: "0.25rem",
              }}
            >
              <FontAwesomeIcon icon={['fas', 'angle-down']} sx={{ opacity: "0.5 !important" }} />
            </Box>
          </Button>
        </Tooltip>
      )}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        slotProps={{
          paper: {
            sx: {
              maxHeight: 600,
              width: 360,
              maxWidth: 'calc(100vw - 24px)',
              overflow: 'hidden',
              borderRadius: '0.75rem',
            },
          },
        }}
      >
        <Grid
          container
          direction="column"
          sx={headerUserMenuGridSx}
        >
          <Box
            sx={{
              py: '1.5rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box sx={[{ borderRadius: '0.65rem' }, {
              "html[data-color-mode=\"dark\"] &": { backgroundColor: "#2a2a2a !important", borderColor: "rgba(255, 255, 255, 0.28) !important", color: "rgba(255, 255, 255, 0.7) !important" },
            }]} data-hf="dropzone">
              <Box
                {...getRootProps()} sx={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  outline: "none !important",
                  "& *": { outline: "none !important" },
                }}
              >
                <input {...getInputProps()} />
                <Box sx={[{
                  height: "140px !important",
                  width: "140px !important",
                  lineHeight: "140px !important",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: 0,
                  borderRadius: "0.65rem",
                }, {
                  padding: "3rem 1rem",
                  cursor: "initial",
                  transition: "all 0.2s ease-in-out",
                  textAlign: "center",
                  color: "#a6a6b9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  border: "2px dashed #e6e7f1",
                  borderRadius: "0.65rem",
                  backgroundColor: "#f8f9ff",
                  "&:hover": { borderColor: "#368cff", color: "#4f5062" },
                  "html[data-color-mode=\"dark\"] &": { backgroundColor: "#2a2a2a !important", borderColor: "rgba(255, 255, 255, 0.28) !important", color: "rgba(255, 255, 255, 0.7) !important" },
                  "html[data-color-mode=\"dark\"] &:hover": { borderColor: "#368cff !important", color: "rgba(255, 255, 255, 0.87) !important", backgroundColor: "#333 !important" },
                  "& [data-hf=\"avatar-image\"], & .avatar-image": {
                    position: "absolute",
                    left: 0,
                    top: 0,
                    zIndex: 4,
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    border: 0,
                  },
                  "& .avatar-button, & [data-hf=\"avatar-button\"]": { zIndex: 5 },
                }]} data-hf="dropzone-inner">
                  <Box sx={[{
                    height: "140px !important",
                    width: "140px !important",
                    lineHeight: "140px !important",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 0,
                    borderRadius: "0.65rem",
                    m: "0.5rem",
                  }, {
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mr: "0.25rem",
                    position: "relative",
                    fontSize: "1.2rem",
                    transition: "all 0.2s ease-in-out",
                    "&:last-child": { mr: 0, marginRight: 0 },
                    "& .badge": { position: "absolute", right: 0, bottom: 0 },
                    "& svg, & .svg-inline--fa": { display: "block" },
                    marginRight: "0.25rem",
                  }]}>
                    <Tooltip title="Upload Personal Image">
                      <Button onClick={open} sx={[{
                        display: "inline-flex",
                        py: 0,
                        px: 0,
                        fontSize: "70%",
                        fontWeight: 700,
                        lineHeight: "40px !important",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        verticalAlign: "baseline",
                        borderRadius: "50%",
                        textTransform: "uppercase",
                        alignItems: "center",
                        justifyContent: "center",
                        border: 0,
                        backgroundImage: "none",
                        borderColor: "#4191ff",
                        "&:not(:disabled):hover": { backgroundColor: "#4191ff", color: "#fff" },
                        "&:not(:disabled).active, &:not(:disabled).active:hover, &:not(:disabled):active": { backgroundColor: "#0e73ff" },
                        "&:not(:disabled):active": { boxShadow: "0 0.22rem 0.525rem rgba(65, 145, 255, 0.4), 0 0.0625rem 0.385rem rgba(65, 145, 255, 0.54)" },
                        "&:not(:disabled).active .btn-wrapper--icon svg path, &:hover .btn-wrapper--icon svg path": { fill: "#fff" },
                        position: "absolute !important",
                        right: 0,
                        bottom: 0,
                        top: "auto",
                        zIndex: 2,
                      }, headerUserUploadBtnSx]}>
                        <CameraAltTwoToneIcon  sx={{
                          height: "20px !important",
                          width: "20px !important",
                          lineHeight: "20px !important",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          p: 0,
                        }}/>
                      </Button>
                    </Tooltip>

                    <div>
                      {isDragAccept && (
                        <Box
                         
                          sx={{
                            height: "140px !important",
                            width: "140px !important",
                            lineHeight: "140px !important",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            borderRadius: "0.65rem",
                            overflow: "hidden",
                            backgroundColor: "#1bc943",
                            textAlign: "center",
                            fontWeight: 700,
                            color: "#fff",
                          }}
                        >
                          <CheckIcon  sx={{
                            height: "40px !important",
                            width: "40px !important",
                            lineHeight: "40px !important",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                          }}/>
                        </Box>
                      )}
                      {isDragReject && (
                        <Box
                         
                          sx={{
                            height: "140px !important",
                            width: "140px !important",
                            lineHeight: "140px !important",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            borderRadius: "0.65rem",
                            overflow: "hidden",
                            backgroundColor: "#f83245",
                            textAlign: "center",
                            fontWeight: 700,
                            color: "#fff",
                          }}
                        >
                          <CloseTwoToneIcon  sx={{
                            height: "60px !important",
                            width: "60px !important",
                            lineHeight: "60px !important",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                          }}/>
                        </Box>
                      )}
                      {!isDragActive && (
                        <Box
                         
                          sx={{
                            height: "140px !important",
                            width: "140px !important",
                            lineHeight: "140px !important",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            p: 0,
                            backgroundColor: "rgb(96.1617647059%, 96.1617647059%, 97.0147058824%) !important",
                            borderRadius: "0.65rem",
                            overflow: "hidden",
                            textAlign: "center",
                            fontWeight: 700,
                            color: "rgba(7, 9, 25, 0.5)",
                          }}
                        >
                          {/* <FontAwesomeIcon
                          icon={['fas', 'building']}
                        /> */}
                          <Box
                            component="img"
                            src={HousefoliosUser}
                            alt="..."
                            sx={headerUserPlaceholderImgSx}
                          />
                        </Box>
                      )}
                    </div>

                    {thumbs.length > 0 && <div>{thumbs}</div>}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          <Grid>
            <Typography sx={headerUserMenuNameSx}>
              {props.session.me.profile.firstname}{' '}
              {props.session.me.profile.lastname}
            </Typography>
          </Grid>
          <Grid>
            <Typography sx={headerUserMenuEmailSx}>
              {props.session.me.email || props.session.me.username}
            </Typography>
          </Grid>
          <Grid
            container
            direction="column"
            spacing={1}
            sx={{
              alignItems: 'center',
              px: 2,
              pb: 1.5,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: 'text.secondary',
                alignSelf: 'flex-start',
                mb: 0.5,
              }}
            >
              Appearance
            </Typography>
            <ColorModeToggle />
          </Grid>
          <Grid>
            <Grid
              container
              direction="row"
              spacing={1}
              wrap="nowrap"
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Grid>
                <Tooltip title="Personal Page">
                  <Button
                    href="/settings/personal"
                    sx={headerUserActionPrimarySx}
                  >
                    <FontAwesomeIcon
                      sx={headerUserWhiteIconSx}
                      icon={['far', 'user']}
                      size="2x"
                    />
                  </Button>
                </Tooltip>
              </Grid>
              <Grid>
                <Tooltip title="Billing Page">
                  <Button
                    href="/settings/billing"
                    sx={headerUserActionBillingSx}
                  >
                    <FontAwesomeIcon
                      sx={headerUserWhiteIconSx}
                      icon={['fas', 'file-invoice-dollar']}
                      size="2x"
                    />
                  </Button>
                </Tooltip>
              </Grid>

              <Grid>
                <ApolloConsumer>
                  {(client) => (
                    <Tooltip title="Log Out">
                      <Button
                        onClick={() =>
                          signOut(
                            client,
                            props?.session?.me?.activeOrg?.member,
                          )
                        }
                        sx={headerUserActionLogoutSx}
                      >
                        <FontAwesomeIcon
                          sx={headerUserWhiteIconSx}
                          icon={['fas', 'right-from-bracket']}
                          size="2x"
                        />
                      </Button>
                    </Tooltip>
                  )}
                </ApolloConsumer>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Divider />
        <Box
          onKeyDown={(event) => event.stopPropagation()}
          sx={[
            {
              position: "relative",
              "&::before, &::after": {
                width: "100%",
                left: 0,
                height: "1rem",
                position: "absolute",
                zIndex: 4,
                content: "\"\"",
              },
              "&::before": { top: 0, background: "linear-gradient(to bottom, rgba(255,255,255,1) 20%, rgba(255,255,255,0) 100%)" },
              "&::after": { bottom: 0, top: "auto", background: "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 80%)" },
              "html[data-color-mode=\"dark\"] &::before": { background: "linear-gradient(to bottom, rgb(30, 30, 30) 20%, rgba(30, 30, 30, 0) 100%)" },
              "html[data-color-mode=\"dark\"] &::after": { background: "linear-gradient(to bottom, rgba(30, 30, 30, 0) 0%, rgb(30, 30, 30) 80%)" },
            },
            { overflowX: 'hidden', overflowY: 'auto', height: 215 },
          ]}
        >
          <Box sx={{
            position: "relative",
            height: "100%",
            maxHeight: "100%",
            overflowX: "hidden",
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
          }}>
            <List component="div" sx={{
              paddingTop: 0,
              paddingBottom: 0,
              "& .MuiListItem-root, & .MuiListItemButton-root": {
                width: "100%",
                padding: "0.75rem 1.25rem",
                backgroundColor: "#fff",
                border: "1px solid rgba(0, 0, 0, 0.125)",
                borderRadius: 0,
                margin: 0,
                borderWidth: "0 0 1px",
                "&.MuiListItem-button": {
                  borderRadius: 0,
                  borderWidth: "0 0 1px",
                  "& .MuiTouchRipple-root": { opacity: 0.2 },
                },
                "&.list-group-item-action": { transition: "all 0.2s ease-in-out" },
                "&.MuiListItem-button:hover, &.list-group-item-action:hover": { background: "#f4f5fd", zIndex: 1 },
                "&.MuiListItem-button:active, &.list-group-item-action:active": { color: "#000", backgroundColor: "#eeeff8" },
                "&:first-of-type": { borderTop: "0 !important" },
                "&:last-child": { borderBottom: "0 !important" },
              },
              "html[data-color-mode=\"dark\"] & .MuiListItem-root, html[data-color-mode=\"dark\"] & .MuiListItemButton-root": {
                backgroundColor: "#1e1e1e !important",
                borderColor: "rgba(255, 255, 255, 0.12) !important",
                color: "rgba(255, 255, 255, 0.87) !important",
              },
              "html[data-color-mode=\"dark\"] & .MuiListItem-root.MuiListItem-button:hover, html[data-color-mode=\"dark\"] & .MuiListItemButton-root:hover": {
                background: "#2a2a2a !important",
              },
            }}>
              {compact(
                map(props.session.me.roles, (roleOrg) => {
                  if (
                    !roleOrg.organization ||
                    roleOrg.role[0] === 'deactive' ||
                    roleOrg.organization._id === 'superAdmin'
                  ) {
                    return null
                  }
                  if (
                    roleOrg.organization._id ===
                    props.session.me.activeOrg._id
                  )
                    return (
                      <OrgSwitcherRow
                        key={roleOrg.organization._id}
                        component="a"
                        href="/settings/organization"
                        name={roleOrg.organization.name}
                        selected
                        iconBg="#28b854"
                      >
                        <FontAwesomeIcon
                          icon={['far', 'building']}
                          sx={headerUserWhiteIconSx}
                        />
                      </OrgSwitcherRow>
                    )
                  else
                    return (
                      <OrgSwitcherRow
                        key={roleOrg.organization._id}
                        name={roleOrg.organization.name}
                        selected={false}
                        iconBg="#797d95"
                        onClick={(e) => {
                          const preventRefresh = (e) => {
                            e.preventDefault()
                            e.returnValue =
                              'Refreshing right now could result in lost data. Do you wish to continue?'
                          }
                          window.addEventListener(
                            'beforeunload',
                            preventRefresh,
                          )
                          updateUser({
                            variables: {
                              userInput: {
                                organization:
                                  roleOrg.organization._id,
                              },
                            },
                            refetchQueries: [
                              {
                                query: GET_ME,
                              },
                              {
                                query: GET_PORTFOLIOS,
                              },
                              {
                                query: GET_SIDEBAR_PORTFOLIOS,
                              },
                            ],
                          }).then(({ data  }) => {
                            localStorage.setItem(
                              'token',
                              data.updateUser.token,
                            )
                            window.removeEventListener(
                              'beforeunload',
                              preventRefresh,
                            )
                            navigate(
                              get(
                                props.session.me,
                                'preferences.general.defaultPage.value',
                              ) ||
                                get(
                                  roleOrg,
                                  'organization.preferences.general.defaultPage.value',
                                ) ||
                                '/launchpad',
                            )
                            handleClose()
                            window.location.reload()
                          })
                        }}
                      >
                        <FontAwesomeIcon
                          icon={['far', 'building']}
                          sx={headerUserWhiteIconSx}
                        />
                      </OrgSwitcherRow>
                    )
                }),
              )}
              {Boolean(anchorEl) && <CreateNewOrg listItem />}
            </List>
          </Box>
        </Box>
        {/* <div>
          <Button size="small">
            Action
          </Button>
          <Button
            variant="text"
            size="small">
            <span>View details</span>
          </Button>
        </div> */}
        {/* </div> */}
      </Menu>
    </>
  )
}

export default withSession(HeaderUserbox)
